'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    max-width: 100%;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    max-width: 100%;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  //   padding-left: 23px;\n  //   padding-right: 23px;\n  // "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  //   padding-left: 21px;\n  //   padding-right: 21px;\n  // "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n\n  // ", ";\n  //  \n  // ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    @media (max-width: 1097px) {\n      ", ";\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: 1098px) {\n      ", ";\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: 1400px) {\n      ", ";\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: 1098px) and (max-width: 1399px) {\n      ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: 768px) and (max-width: 1097px) {\n      ", ";\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    @media (min-width: 480px) and (max-width: 767px) {\n      ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media (max-width: 479px) {\n      ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.media = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var media = exports.media = {
  mobile: function mobile() {
    return _styledComponents.css(_templateObject(), (0, _styledComponents.css).apply(void 0, arguments));
  },
  tabletsLow: function tabletsLow() {
    return _styledComponents.css(_templateObject2(), (0, _styledComponents.css).apply(void 0, arguments));
  },
  tablets: function tablets() {
    return _styledComponents.css(_templateObject3(), (0, _styledComponents.css).apply(void 0, arguments));
  },
  desktop: function desktop() {
    return _styledComponents.css(_templateObject4(), (0, _styledComponents.css).apply(void 0, arguments));
  },
  desktopHigh: function desktopHigh() {
    return _styledComponents.css(_templateObject5(), (0, _styledComponents.css).apply(void 0, arguments));
  },
  allDektops: function allDektops() {
    return _styledComponents.css(_templateObject6(), (0, _styledComponents.css).apply(void 0, arguments));
  },
  allMobiles: function allMobiles() {
    return _styledComponents.css(_templateObject7(), (0, _styledComponents.css).apply(void 0, arguments));
  }
};

var Container = exports.Container = _styledComponents2.default.div(_templateObject8(), media.mobile(_templateObject9()), media.tabletsLow(_templateObject10()), media.tablets(_templateObject11()), media.allDektops(_templateObject12()));